import React from 'react';

export const createRobotsTagNoIndex = (hasMarket: boolean, vehicleId: boolean) => {
  return hasMarket && vehicleId ? null : <meta name="robots" content="noindex" />;
};
